import { UIPosition } from 'types';
import { PositionSkill } from './PositionDrawer';
import SkillBadge from 'src/components/recruiterPositions/SkillBadge';

interface Props {
	position: UIPosition;
	positionSkills: PositionSkill[];
}

const RecruiterTechnicalSkillsRequired = ({ positionSkills }: Props) => {
	return (
		<>
			{positionSkills && positionSkills?.length > 0 ? (
				<div className="mb-[24px] rounded-[8px] bg-white border border-[#7777E7] dark:border-0 dark:bg-[#1F2A37] p-4 shadow-md dark:shadow-none">
					<div className="text-lg font-medium dark:text-[#CCDDFF]">Technical Skills required</div>

					<div className="flex gap-3 flex-wrap p-2 mt-[6px]">
						{positionSkills.map((ps, i) => (
							<SkillBadge key={i} content={<>{ps.name}</>} />
						))}
					</div>
				</div>
			) : null}
		</>
	);
};

export default RecruiterTechnicalSkillsRequired;
